module.exports = __webpack_public_path__ + "static/media/file-with-check.f556c7d8.svg";